import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

// No app desktop (Electron), faz a BARRA DE TÍTULO nativa (botões fechar/
// maximizar/minimizar) acompanhar o modo light/dark do app, sincronizando o
// nativeTheme do Electron com o palette.mode. Sem efeito no navegador
// (window.desktop só existe no app).
export default function DesktopThemeSync() {
  const theme = useTheme();

  useEffect(() => {
    const desktop = (window as unknown as { desktop?: { setNativeTheme?: (s: string) => void } }).desktop;
    if (!desktop?.setNativeTheme) return;
    desktop.setNativeTheme(theme.palette.mode === 'dark' ? 'dark' : 'light');
  }, [theme.palette.mode]);

  return null;
}
